/**
 * Cart comparison utilities ported from `ometrics-ai` (v1).
 * Used by abandoned cart + upsell detection.
 */
 
export function equal(a, b) {
  if (a === b) return true
 
  if (a && b && typeof a === 'object' && typeof b === 'object') {
    if (a.constructor !== b.constructor) return false
 
    if (Array.isArray(a)) {
      if (a.length !== b.length) return false
      for (let i = a.length; i-- !== 0; ) {
        if (!equal(a[i], b[i])) return false
      }
      return true
    }
 
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags
 
    const keys = Object.keys(a)
    if (keys.length !== Object.keys(b).length) return false
    for (let i = keys.length; i-- !== 0; ) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false
    }
    for (let i = keys.length; i-- !== 0; ) {
      const key = keys[i]
      if (!equal(a[key], b[key])) return false
    }
    return true
  }
 
  // true if both NaN
  return a !== a && b !== b
}
 
/**
 * Minimal cart payload for the abandoned-cart whisper.
 * The server only needs product_id (and title for logging); product cards are
 * loaded server-side. Sending the full storefront cart (image URLs, etc.)
 * base64-encoded routinely exceeds the chat API message length limit.
 *
 * @param {object|null|undefined} cartData
 * @returns {{ token: string, currency: *, items: Array<{ product_id: *, title: string, quantity: * }> }}
 */
export function serializeAbandonedCartForWhisper(cartData) {
  const items = Array.isArray(cartData?.items) ? cartData.items : []
  return {
    token: cartData?.token ?? '',
    currency: cartData?.currency ?? '',
    items: items
      .filter((item) => item && item.product_id != null && item.product_id !== '')
      .map((item) => ({
        product_id: item.product_id,
        title: typeof item.title === 'string' ? item.title : '',
        quantity: item.quantity ?? 1,
      })),
  }
}

/**
 * Returns the product_id of the first new item in `newCart` compared to `oldCart`.
 */
export function checkUpsell(oldCart, newCart) {
  if (!newCart || !Array.isArray(newCart.items)) return ''
  const oldItems = Array.isArray(oldCart?.items) ? oldCart.items : []
  for (let i = 0; i < newCart.items.length; i += 1) {
    let found = false
    for (let j = 0; j < oldItems.length; j += 1) {
      if (newCart.items[i].product_id === oldItems[j].product_id) {
        found = true
        break
      }
    }
    if (!found) return newCart.items[i].product_id || ''
  }
  return ''
}

